import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SnotifyService } from 'ng-snotify';
import { environment } from '../../environments/environment';
import { Page } from '../models/paging/page';
import { PagedData } from '../models/paging/paged-data';

@Injectable()
export class WebUserService {
    constructor(private http: HttpClient, private snotifyService: SnotifyService) {
    }

    public get(id: string = null): Promise<any> {
        return new Promise((resolve, reject) => {
            this.http.get<any>(environment.apiUrl + "account/get?id=" + id).subscribe(data => {
                resolve(data);
            }, error => {
                ////console.log(error);
                reject();
            });
        });
    }
    //this.filter.company_Id, this.filter.location_Id, this.filter.name, this.filter.email
    public getTable(page: Page, company_Id: number, location_Id: number, name: string, email: string): Promise<any> {
        const pagedData = new PagedData<any>();
        return new Promise((resolve, reject) => {
            if (page.sortBy == undefined || page.sortBy == '') { page.sortBy = 'firstname'; }
            if (page.sortOrder == undefined || page.sortOrder == '') { page.sortOrder = 'asc'; }
            let params = '&company_Id=' + company_Id;
            params += '&location_Id=' + location_Id;
            params += '&name=' + name;
            params += '&email=' + email;

            this.http.get<any>(environment.apiUrl + "account/gettable?"
                + "size=" + page.size + '&pageNumber=' + page.pageNumber + '&sortBy=' + page.sortBy + '&sortOrder=' + page.sortOrder
                + params).subscribe(data => {


                    page.totalElements = data.totalElements;
                    page.totalPages = page.totalElements / page.size;

                    for (let i = 0; i < data.data.length; i++) {
                        const jsonObj = data.data[i];
                        pagedData.data.push(jsonObj);
                    }

                    pagedData.page = page;
                    resolve(pagedData);

                }, error => {
                    //console.log(error);
                    reject();
                });
        });
    }


    public add(user): Promise<any> {
        return new Promise((resolve, reject) => {
            ////console.log(user);
            this.http.post<any>(environment.apiUrl + 'account/post', user).subscribe(data => {
                resolve(data);
                this.snotifyService.success('Successfully added web user');
            }, error => {
                //console.log(error);
                 this.snotifyService.error(error.error);
                reject();
            });
        });
    }

    public update(user): Promise<any> {
        return new Promise((resolve, reject) => {
            this.http.put<any>(environment.apiUrl + 'account/put', user).subscribe(data => {
                resolve(data);
                this.snotifyService.success('Successfully updated web user');
            }, error => {
                ////console.log(error);
                reject();
            });
        });
    }

    public delete(id): Promise<any> {
      return new Promise((resolve, reject) => {
          this.http.delete<any>(environment.apiUrl + 'account/delete?id=' + id).subscribe(data => {
              resolve(data);
              this.snotifyService.success('Successfully added web user');
          }, error => {
              ////console.log(error);
              reject();
          });
      });
  }

    public getProfiles(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.http.get<any>(environment.apiUrl + 'account/getusertypes').subscribe(data => {
                resolve(data);
            }, error => {
                ////console.log(error);
                reject();
            });
        });
    }
}
